import { createContext, useContext } from 'react';
var RadioGroupContext =
/*#__PURE__*/
createContext(null);
var RadioGroupProvider = RadioGroupContext.Provider;

var useRadioGroupContext = function useRadioGroupContext() {
  return useContext(RadioGroupContext);
};

export { RadioGroupProvider, useRadioGroupContext };